<template>
  <div id="app">
    <LanguageSelector
      v-model="languages"
      :searchAPI="searchAPI"
      v-slot="{
        searchResultsByScript,
        getAutonym,
        getDir,
        inputAttrs,
        inputEvents,
      }"
    >
      <div class="uls">
        <input
          type="search"
          class="language-search-query"
          placeholder="Search language..."
          v-on="inputEvents"
          v-bind="inputAttrs"
        />

        <div class="results" v-if="Object.keys(searchResultsByScript).length">
          <h3>Search results</h3>
          <div
            class="script"
            v-for="(languagesInScript, script) in searchResultsByScript"
            :key="script"
          >
            <a
              class="language"
              v-for="language in languagesInScript"
              :key="language"
              :lang="language"
              :dir="getDir(language)"
              :href="`https://${language}.wikipedia.org`"
            >
              {{ getAutonym(language) }}
            </a>
          </div>
        </div>
        <div class="no-results" v-else>
          <h3>No results</h3>
        </div>
      </div>
    </LanguageSelector>
  </div>
</template>

<script>
import LanguageSelector from "./components/LanguageSelector";

export default {
  name: "App",
  data() {
    return {
      searchAPI:
        "https://en.wikipedia.org/w/api.php?action=languagesearch&format=json&formatversion=2",
      //languages: ["en", "es", "fr", "hi", "or", "ta", "ml", "zh"],
    };
  },
  components: {
    LanguageSelector,
  },
};
</script>

<style>
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  margin-top: 5vh;
  color: #333;
}

.no-results,
.results {
  border: 1px solid #999;
  border-top: 0;
  border-radius: 4px;
  border-top-left-radius: 0;
  border-top-right-radius: 0;
  padding: 8px;
  min-height: 50vh;
  max-height: 50vh;
  overflow: auto;
}

.language-search-query {
  padding: 8px;
  font-size: 1em;
  line-height: 1.5;
  width: 100%;
  border-radius: 4px;
  border: 1px solid #999;
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
}

.script {
  margin: 1em 0;
  text-align: left;
  column-count: 3;
}

@media (max-width: 600px) {
  .script {
    column-count: 1;
  }
}

.language {
  display: block;
  padding: 4px;
  font-size: 1em;
  text-decoration: none;
}
</style>
